module.exports = __webpack_public_path__ + "static/media/bus-alt.02b6ae35.svg";